<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import type { SimpleFetchResult } from 'hydria/services/session'
    import { simpleFetch } from 'hydria/services/session'
    import { sgoto } from 'hydria/svelte_helpers'

    import type { AdminUser } from './user'

    interface Props {
        user: AdminUser
    }

    let { user }: Props = $props()

    let reason: string = $state('')

    let deleting = $state(false)
    async function deleteUser() {
        deleting = true

        let r: SimpleFetchResult

        try {
            r = await simpleFetch('DELETE', `/json/users/1/${user.id}`)
        } catch (e: any) {
            console.error('Failed to unlock:', e)
            notify({
                type: 'danger',
                title: $_('Delete user'),
                text: 'The account could not be deleted' + (e && e.data && e.data.error ? ` : ${e.data.error}` : '.'),
            })

            deleting = false
            return
        }

        notify({
            type: 'success',
            title: $_('Delete user'),
            text: $_('The account has been deleted.'),
        })
        sgoto('/admin-users')
    }
</script>

<div class="panel panel-info">
    <div class="panel-heading">{$_('Delete')}</div>

    <div class="panel-body">
        <textarea id="userDeleteReason" disabled={deleting} class="form-control" bind:value={reason}></textarea>

        {#if !deleting}
            <button type="button" class="btn btn-danger" onclick={() => deleteUser()}>{$_('Delete user (without confirmation)')}</button>
        {:else}
            <button type="button" class="btn btn-info" disabled>
                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                {$_('Working…')}
            </button>
        {/if}
    </div>
</div>
